import { Link } from 'react-router-dom';
import './Footer.css';
import { trackEvent } from '../utils/analytics';

interface FooterProps {
  invert?: boolean;
  withDeco?: boolean;
}

export default function Footer({ invert = false, withDeco = false }: FooterProps) {
  const footerLinks = [
    { text: 'プライバシーポリシー', link: '/privacy-policy' },
    { text: 'ご利用規約', link: '/terms-of-service' },
    { text: '特定商取引に基づく表記', link: '/commercial-transactions' },
  ];

  const footerContent = (
    <footer className={`footer ${invert ? 'invert' : ''}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="logo">
              <img src="/assets/images/mobile-logo.png" alt="logo" />
              <h6 className="title">LessonMate</h6>
            </div>
            <div className="footer-links">
              {footerLinks.map((link, index) => (
                <span key={link.text}>
                  <Link to={link.link}>{link.text}</Link>
                  {index < footerLinks.length - 1 && <span className="separator">|</span>}
                </span>
              ))}
            </div>
            <p className="body-2 text-center copyright">&copy; LessonMate {new Date().getFullYear()}</p>
          </div>
        </div>
      </div>
    </footer>
  );

  if (withDeco) {
    return (
      <div className="footer-deco">
        <svg className="deco-top back">
          <g stroke="none" strokeWidth="1" fillRule="evenodd">
            <path d="M1386.4643,103.875458 C1327.51727,62.8200781 1249.60548,39.8591094 1152.72894,34.9925522 C850.71695,19.8210915 538.480567,295 326.930474,295 C185.897079,295 76.9202543,248.310715 -7.01987236e-14,154.932144 L0,0 L1386.4643,0 L1386.4643,103.875458 Z"></path>
          </g>
        </svg>
        <svg className="deco-top cover">
          <g stroke="none" strokeWidth="1" fillRule="evenodd">
            <path d="M1386.4643,103.875458 C1327.51727,62.8200781 1249.60548,39.8591094 1152.72894,34.9925522 C850.71695,19.8210915 538.480567,295 326.930474,295 C185.897079,295 76.9202543,248.310715 -7.01987236e-14,154.932144 L0,0 L1386.4643,0 L1386.4643,103.875458 Z"></path>
          </g>
        </svg>
        <div className="decoration"></div>
        <div className="action">
          <h4 className="use-text-subtitle">今すぐダウンロードして、はじめよう。</h4>
          <div className="btn-area">
            <a
              href="https://apps.apple.com/jp/app/lessonmate/id6751098543"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                trackEvent('store_click', {
                  store: 'app_store',
                  placement: 'landing_footer',
                });
              }}
            >
              <img src="/assets/images/mobile/app-store.png" alt="app store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=inc.ludicrous.lessonmate"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                trackEvent('store_click', {
                  store: 'google_play',
                  placement: 'landing_footer',
                });
              }}
            >
              <img src="/assets/images/mobile/play-store.png" alt="play store" />
            </a>
          </div>
        </div>
        {footerContent}
      </div>
    );
  }

  return footerContent;
}

